/* eslint-disable camelcase */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import { RkPayContent } from '@pages/signup/components';
import PaymentMethodForm from '../../../components/AddPaymentMethodModal/PaymentMethodForm';

class SignUp extends PureComponent {
	redirectToAccount = () => {
		const { history } = this.props;
		history.push('/account#payment');
	}

	render() {
		const { user } = this.props;

		if (user.IsRKPay) return <Redirect to="/payments" />;

		const userAddress = {
			address_line1 : user.StreetAddress,
			address_city  : user.City,
			_state        : user.StateId,
			address_state : `${user.StateAbbreviation} - ${user.StateName}`,
			address_zip   : user.Zip,
		};

		return (
			<Row>
				<Col
					md={5}
					mdOffset={2}
					sm={6}
					smOffset={1}
					xs={11}
					xsOffset={1}
					className="z-index-2 panel signup-panel margin-bottom-10"
				>
					<PaymentMethodForm
						user={user}
						successCallback={this.redirectToAccount}
						onCancel={this.redirectToAccount}
						userAddress={userAddress}
					/>
				</Col>
				<Col
					md={4}
					sm={5}
					className="rk-pay-content-page"
				>
					<RkPayContent />
				</Col>
			</Row>
		);
	}
}

const mapStateToProps = ({ app : { user } }) => ({
	user,
});

SignUp.propTypes = {
	user    : PropTypes.object,
	history : PropTypes.object.isRequired,
};

SignUp.defaultProps = {
	user : {},
};

export default connect(mapStateToProps)(SignUp);
